import React from 'react';

import { Tooltip, IconButton } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

interface HelpTooltipProps {
    label: string;
}

const HelpTooltip: React.FC<HelpTooltipProps> = ({ label }) => (
    <Tooltip title={label}>
        <IconButton>
            <HelpOutlineIcon sx={{ fontSize: '1.2rem' }} />
        </IconButton>
    </Tooltip>
);

export default HelpTooltip;
